import React from 'react';
import { motion } from 'framer-motion';
interface FloatingOrbsProps {
  count?: number;
  className?: string;
}
export const FloatingOrbs: React.FC<FloatingOrbsProps> = ({
  count = 12,
  className = ''
}) => {
  return <div className={`absolute inset-0 pointer-events-none overflow-hidden ${className}`} data-id="element-206">
      {[...Array(count)].map((_, i) => <motion.div key={`orb-${i}`} className="absolute w-2 h-2 pointer-events-none z-[2]" style={{
      left: `${10 + i * 7 % 80}%`,
      top: `${20 + i * 11 % 60}%`,
      background: i % 2 === 0 ? 'radial-gradient(circle, rgba(250, 255, 49, 0.9) 0%, transparent 70%)' : 'radial-gradient(circle, rgba(21, 200, 255, 0.9) 0%, transparent 70%)',
      boxShadow: i % 2 === 0 ? '0 0 20px rgba(250, 255, 49, 0.8)' : '0 0 20px rgba(21, 200, 255, 0.8)'
    }} animate={{
      y: [0, -25 - i % 3 * 10, 0],
      x: [0, Math.sin(i) * 15, 0],
      scale: [1, 1.3, 1],
      opacity: [0.5, 0.9, 0.5]
    }} transition={{
      duration: 3 + i * 0.5,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: i * 0.2
    }} data-id="element-207" />)}
    </div>;
};